import styled from 'styled-components';
import { CopyOutlined } from '@ant-design/icons';

export const StyledCopyIcon = styled(CopyOutlined)`
    color: var(--gray-9);

    transition: color 0.2s ease;
    &:hover {
        color: var(--brand-5);
    }
`;
